import React from "react";
import "../styles.css";
import "../popup.css";
import "../try.css";
import contactImage from "./../imgs/contact.svg";
import "./Contact.css";
import Nav from "./navbar";
import { useForm } from "react-hook-form";
import Footer from "./footer";

function Contact() {
  const {
    register,
    handleSubmit,

    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);

  return (
    <>
      <Nav />
      <div className="contact-form">
        <div className="contact-div1">
          <h2>Let's connect</h2>

          <div className="contacts-icons">
            {" "}
            <i className="fas contacts-icon fa-envelope"></i>{" "}
            iamZuberDunge@gmail.com
          </div>

          <div className="contacts-icons">
            {" "}
            <i className="fas contacts-icon fa-phone-alt"></i> +91 88 3066 9389
          </div>

          <div className="contacts-icons">
            {" "}
            <i className="fas contacts-icon fa-map-marker-alt"></i> Pune, MH
          </div>
          <img
            style={{ maxWidth: "330px" }}
            src={contactImage}
            alt="contact us"
          />
        </div>

        <form
          name="contact"
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <h2>Send me a message</h2>
          <p>
            <label>
              Name *{" "}
              <input
                type="text"
                name="name"
                placeholder="Name"
                {...register("Name", {
                  required: true,
                  maxLength: 20,
                  pattern: /^[A-Za-z]+$/i,
                })}
              />
              {errors.Name && <p>This field is required</p>}
            </label>
          </p>
          <p>
            <label>
              Twitter/GitHub *
              <input
                required
                type="text"
                name="username"
                placeholder="Twitter/GitHub username"
                {...register("username", {
                  required: true,
                })}
              />
              {errors.username && <p>This field is required</p>}
            </label>
          </p>
          <p>
            <label>
              Email *
              <input
                placeholder="Email"
                {...register("email", {
                  required: "this is required",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors.email && <p>{errors.email.message}</p>}
            </label>
          </p>

          <p>
            <label>
              Message *:{" "}
              <textarea
                {...register("message", {
                  required: true,

                  pattern: /^[A-Za-z]+$/i,
                })}
                name="message"
                placeholder="Message"
              ></textarea>
              {errors.message && <p>This field is required</p>}
            </label>
          </p>
          <p>
            <button onClick={handleSubmit(onSubmit)} className="btn-form">
              Send Message
            </button>
          </p>
        </form>
      </div>
      <Footer />
    </>
  );
}

export default Contact;
